import React from 'react';
import { Link } from 'gatsby';
import styled, { x, th, down, css } from '@xstyled/styled-components';
export var Nav = styled.navBox.withConfig({
  displayName: "Nav",
  componentId: "sc-1gjftm8-0"
})(["", ""], down('md', css(["overflow-x:auto;max-width:calc(100vw - ", ") !important;"], th.px(72))));
var InnerNavLink = styled.aBox.withConfig({
  displayName: "Nav__InnerNavLink",
  componentId: "sc-1gjftm8-1"
})(["display:inline-flex;color:on-background;transition:base;transition-property:color;text-decoration:none;cursor:pointer;&:hover,&:focus{color:on-background-light;}appearance:none;border:0;background:transparent;padding:0;"]);
export var NavLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InnerNavLink, Object.assign({
    ref: ref,
    as: Link
  }, props));
});
export var NavListItem = styled.liBox.withConfig({
  displayName: "Nav__NavListItem",
  componentId: "sc-1gjftm8-2"
})(["list-style-type:none;white-space:nowrap;margin:0;padding:0 2;display:flex;align-items:center;"]);
export var NavList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.ul, Object.assign({
    ref: ref,
    m: 0,
    p: 0,
    row: true,
    alignItems: "center",
    flexWrap: "nowrap"
  }, props));
});